export const checkIsResponseStatus = (status?: number) => {
    return status && status >= 200 && status < 400;
};
